import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  TUTOR_COURSE_LIST_GET,
  TUTOR_EVENT_LIST_GET,
  UPDATE_COURSE_DETAILS_GET,
} from '../actions/tutorCourseList';
import { COURSE_CANCEL, QUIZ_CREATION_RESET } from '../actions/tutors';

const initialState = {
  courseList: { filters: {}, list: [], pager: {} },
  eventList: { filters: {}, list: [], pager: {} },
  details: {},
};

const publicReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case TUTOR_COURSE_LIST_GET._SUCCESS: {
        draft.courseList.list = action?.response?.items || [];
        draft.courseList.pager = action?.pager || {};
        break;
      }

      case UPDATE_COURSE_DETAILS_GET._SUCCESS: {
        draft.details = action?.response || {};
        break;
      }

      case TUTOR_EVENT_LIST_GET._SUCCESS: {
        draft.eventList.list = action?.response?.items || [];
        draft.eventList.pager = action?.pager || {};
        break;
      }

      case QUIZ_CREATION_RESET:
      case COURSE_CANCEL._SUCCESS: {
        draft = initialState;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default publicReducer;
